import React from 'react';
import './ErrorLabel.sass';

interface Props {
	message: string | undefined;
}

function ErrorLabel({ message }: Props) {
	return <span className="error-label error-label--visible">{message}</span>;
}

export default ErrorLabel;
